import React, { useState, useContext, useEffect, useRef } from "react";
// import { getAuth, updateProfile, signOut } from "firebase/auth";
// import { db } from "../Firebase/FirebaseConfig";
// import {
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
//   getStorage,
// } from "firebase/storage";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Fade } from "react-reveal";
// import toast, { Toaster } from "react-hot-toast";
import logo from "../../assets/images/mayaLogo.png";
import payment from "../../assets/images/payment.png";
import { useStripe, useElements, PaymentElement, CardElement } from '@stripe/react-stripe-js';

import { AuthContext } from "../../Context/UserContext";
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CiCirclePlus } from "react-icons/ci";
import Navbar from "../../components/Header/Navbar";
import axiosClient from "../../axios-client";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function Payment() {
    const { user } = useContext(AuthContext);
    const [finalPrice, setFinalPrice] = useState(null);
    const [discount, setDiscount] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const location = useLocation();
    const promoCode = location.state?.promoCode;
    const price = location.state?.price;
    const type = location.state?.subscriptionType;
    const subId = location.state?.subscriptionId;

    const navigate = useNavigate();

    useEffect(() => {
        const calculateFinalPrice = async () => {
            if (!promoCode || !price) {
                setFinalPrice(price);
                return;
            }

            try {
                setLoading(true);
                setError(null);

                const stripeResponse = await axiosClient.post('check-stripe-promo/', { promoCode });
                console.log(stripeResponse);

                if (stripeResponse.data && stripeResponse.data.discount) {
                    const stripeDiscount = stripeResponse.data.discount;
                    const calculatedPrice = price - (price * stripeDiscount / 100);
                    setFinalPrice(calculatedPrice.toFixed(2));
                    setDiscount(stripeResponse.data.discount)
                    return;
                }

                try {
                    const response = await axiosClient.get(`promocodes/name/${promoCode}/`);
                    let promo = response.data;
                    console.log(promo);

                    if (promo && promo.discount) {
                        const discount = promo.discount;
                        const calculatedPrice = price - (price * discount / 100);
                        setFinalPrice(calculatedPrice.toFixed(2));
                        setDiscount(promo.discount)
                    } else {
                        setFinalPrice(price);
                    }
                } catch (err) {
                    setError("Failed to fetch promo details from the database.");
                    setFinalPrice(price);
                    if (!toast.isActive("promo error")) {
                        toast.warning(`Le code promo saisi n'est pas pris en charge car il est invalide ou expiré.`, {
                            toastId: 'promo error',
                            position: "top-right",
                            autoClose: 3000,
                        });
                    }
                }
            } catch (err) {
                setError("Failed to verify promo code with Stripe.");
                setFinalPrice(price);
                if (!toast.isActive("promo error")) {
                    toast.warning(`Le code promo saisi n'est pas pris en charge car il est invalide ou expiré.`, {
                        toastId: 'promo error',
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
            } finally {
                setLoading(false);
            }
        };

        calculateFinalPrice();
    }, [promoCode, price]);



    const stripe = useStripe();
    const elements = useElements();
    const [isProcessing, setIsProcessing] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        setIsProcessing(true);

        try {
            // Get the CardElement
            const cardElement = elements.getElement(CardElement);

            // Create the payment method with the CardElement
            const { paymentMethod, error: createError } = await stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
            });

            if (createError) {
                console.error('Error creating payment method:', createError);
                setIsProcessing(false);
                alert(`Payment setup failed: ${createError.message}`);
                return;
            }

            // Pass the paymentMethod.id to your backend
            const { data, error: apiError } = await axiosClient.post('/create-payment-intent', {
                amount: price,
                currency: 'usd',
                user: user?.id,
                subscriptionType: type,
                promoCode: promoCode,
                subscription: subId,
                paymentMethodId: paymentMethod.id,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(response => ({ data: response.data }))
                .catch(error => ({

                    error: error.response?.data?.error || 'Request failed'
                }));

            if (apiError) {
                // console.error('Backend API error:', apiError);
                setIsProcessing(false);
                toast.error(`Une erreur s'est produite. Veuillez réessayer.`, {
                    position: "top-right",
                    autoClose: 3000,

                });
                console.log(apiError);

                return;
            }

            // Your backend is returning subscriptionId, not clientSecret
            const { subscriptionId, paymentMethodId } = data;

            if (data.requiresAction) {
                const { error, paymentIntent } = await stripe.confirmCardPayment(
                    data.paymentIntentClientSecret,
                    {
                        payment_method: paymentMethod.id
                    }
                );
                if (error) {
                    setIsProcessing(false);
                    console.log(error);

                    toast.error('Authentication failed. Please try again.');
                    return;
                }

                if (paymentIntent.status === 'succeeded') {

                    setTimeout(() => {
                        window.location.href = '/';
                        setIsProcessing(false);
                    }, 10000);
                } else {
                    toast.error('Payment could not be completed.');
                    setIsProcessing(false);
                }
            } else {
                if (data.subscriptionId) {
                    window.location.href = '/';
                } else {
                    console.error('Unexpected response from server');
                    toast.error('Payment processing failed');
                    setIsProcessing(false);
                }
            }
        } catch (error) {
            console.error('Error during payment process:', error);
            toast.error(`Une erreur s'est produite. Veuillez réessayer ultérieurement.`, {
                position: "top-right",
                autoClose: 3000,

            });
            setIsProcessing(false);
        }
        // finally {
        //     setIsProcessing(false);
        // }
    };


    return (
        <div>
            <ToastContainer />

            <div
                className="flex min-h-screen justify-center items-center"
                style={{
                    background: `url(${WelcomePageBanner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <Navbar></Navbar>

                <div className="mt-10 p-5 md:p-12 rounded-md">
                    <div className="py-5 flex justify-center items-center ">
                        <img
                            className="h-10 cursor-pointer w-18"
                            src={logo}
                            alt="NETFLIX"
                        />
                    </div>


                    <div className="min-w-[400px] relative  flex flex-col gap-5 justify-between items-stretch  mb-4 md:mb-8">
                        <div className=" p-5 bg-white  rounded-2xl shadow-xl ">
                            <div className="my-2 flex justify-between">
                                <div className="flex  gap-2">
                                    <p className="text-gray-700 text-3xl font-semibold">
                                        {finalPrice} €
                                    </p>
                                    {discount &&
                                        <span class="bg-red-100 text-red-700 text-xs font-medium me-2 px-2 py-0.5 rounded-full h-fit">-{discount}%</span>

                                    }

                                </div>

                                <img className="h-14 w-14" src={payment} />
                            </div>

                            {user ? (
                                <div className="w-100 text-gray-700 text-sm flex flex-row">
                                    <div className="w-[15%] text-gray-400 ">A </div>
                                    <div >{user.first_name} {user.last_name}</div>
                                </div>
                            ) : (
                                <p className="text-gray-500">Chargement...</p>
                            )}
                            <div className="w-100 text-gray-700 text-sm flex flex-row">
                                <div className="w-[15%] text-gray-400">De </div>
                                <div >Maya+</div>
                            </div>
                        </div>
                        <div className=" p-5 bg-white text-center rounded-2xl shadow-xl flex flex-col justify-between">
                            <form onSubmit={handleSubmit}>
                                <div className="my-5">
                                    <CardElement />
                                </div>

                                <div style={{ width: "100%", display: "flex", justifyContent: "end" }}>
                                    <button className="w-full bg-orange-400 hover:bg-orange-500 transition duration-500 ease-in-out shadow-2xl flex justify-center items-center my-3 py-2 text-xl font-semibold text-white rounded-md text-center"
                                        type="submit" disabled={isProcessing}>
                                        {   isProcessing ?
                                            <div class='flex space-x-2 justify-end items-end '>
                                                <span >Traitement</span>
                                                <div className="mb-1 flex space-x-1 justify-center items-center">
                                                    <div class='h-1 w-1 bg-white rounded-full animate-pulse [animation-delay:-0.3s]'></div>
                                                    <div class='h-1 w-1 bg-white rounded-full animate-pulse [animation-delay:-0.15s]'></div>
                                                    <div class='h-1 w-1 bg-white rounded-full animate-pulse'></div>
                                                </div>

                                            </div> : 'Payer'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Payment;
